import React from "react";
import { Button, Container } from "reactstrap";
import * as _ from "lodash";

import ButtonHelper from "../../../helpers/ButtonHelper";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";

import Filters from "../_components/Filters";
import useExport from "../_hooks/useExport";
import useReport from "../_hooks/useReport";
import PreviewPDF from "../../../helpers/previewPDF";
import UnitsLineBar from "../_components/UnitsLineBar";
import OperatorLineBar from "../_components/OperatorLineBar";
import GraphTitle from "../_components/GraphTitle";

import ConfigModal from "./ConfigModal";
import useVeladasGraph from "./hooks/useVeladasGraph";

import "react-datepicker/dist/react-datepicker.css";

const unitReportName = "graficaVeladasPorUnidadReport";
const operatorReportName = "graficaVeladasPorOperadorReport";

const unitColumns = [
  {
    id: "counter",
    name: "#",
    selector: (row) => row.counter,
    sortable: true,
    width: "70px",
  },
  {
    id: "no",
    name: "Unidad",
    selector: (row) => row.number,
    sortable: true,
  },
  {
    id: "Veladas",
    name: "Veladas",
    selector: (row) => row.veladas,
    sortable: true,
  },
];

const operatorColumns = [
  {
    id: "counter",
    name: "#",
    selector: (row) => row.counter,
    sortable: true,
    width: "70px",
  },
  {
    id: "no",
    name: "Operador",
    selector: (row) => row.fullname,
    sortable: true,
  },
  {
    id: "Veladas",
    name: "Veladas",
    selector: (row) => row.veladas,
    sortable: true,
  },
];

const VeladasGraph = ({ horarioVelada }) => {
  const {
    items,
    routes,
    filters,
    branches,
    validation,
    reportName,
    isUnitReport,
    isLoadingReport,
  } = useReport({
    unitReportName,
    operatorReportName,
    filterValues: {
      time: horarioVelada,
    },
  });

  const {
    chartRef,
    modalPdf,
    fileName,
    setModalPdf,
    isDownloadingGraph,
    isDownloadingReport,
    handleDownloadGraph,
    handleDownloadReport,
  } = useExport({
    filters,
    reportName,
    isUnitReport,
    fileNamePrefix: "veladas-por",
  });

  const { configModal, setConfigModal, completeConfigHandler } =
    useVeladasGraph(validation);

  const title = `Veladas por ${isUnitReport ? "unidad" : "operador"}`;
  const columns = isUnitReport ? unitColumns : operatorColumns;

  document.title = title;

  return (
    <React.Fragment>
      <div className="page-content chart-report">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle={title}
              columns={columns}
              items={items}
              pending={isLoadingReport}
              config={{}}
              filters={{}}
              setFilters={() => {}}
              filterInp={false}
              pagination={false}
            >
              <div className="mb-3">
                <ButtonHelper
                  reportButons
                  addButon={false}
                  actionReportButon={handleDownloadReport}
                  isDownloadingReport={isDownloadingReport}
                >
                  <Button
                    className="btn-sm float-end me-2"
                    type="button"
                    value={"Config"}
                    onClick={(e) => setConfigModal({ show: true })}
                  >
                    <i className="fa fa-cogs"></i> Configurar
                  </Button>
                </ButtonHelper>
              </div>
              <Filters
                routes={routes}
                branches={branches}
                validation={validation}
              />
              <div className="col-md-12 text-end">
                {isUnitReport && (
                  <Button
                    size="sm"
                    color="primary"
                    onClick={handleDownloadGraph}
                    disabled={isDownloadingGraph}
                    tittle="Descargar grafica"
                  >
                    {isDownloadingGraph ? (
                      <i className="bx bx-hourglass bx-spin font-size-16 align-middle"></i>
                    ) : (
                      <i className="fas fa-download"></i>
                    )}
                  </Button>
                )}
              </div>
              {items?.length && !isLoadingReport ? (
                <div className="col-md-12">
                  <GraphTitle
                    title="Gráfica de veladas por"
                    validation={validation}
                    branches={branches}
                  />
                  {isUnitReport ? (
                    <UnitsLineBar
                      yKey="veladas"
                      label="Veladas"
                      data={items}
                      chartRef={chartRef}
                    />
                  ) : (
                    <OperatorLineBar
                      yKey="veladas"
                      label="Veladas"
                      data={items}
                      chartRef={chartRef}
                    />
                  )}
                </div>
              ) : null}
            </DataTableHelper>
          </div>
        </Container>
      </div>
      {modalPdf.show && (
        <PreviewPDF
          title={title}
          modalPdf={modalPdf}
          setModalPdf={setModalPdf}
          fileName={`${fileName}.pdf`}
        />
      )}
      {configModal.show && (
        <ConfigModal
          modal={configModal}
          setModal={setConfigModal}
          completeHandler={completeConfigHandler}
          horarioVelada={validation.values.time}
        />
      )}
    </React.Fragment>
  );
};

export default VeladasGraph;
